import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { moduleActions } from '../../../redux/modules';
import './QCDFundsList.scss';
import ExpandedFundList from '../../Buy/BuyFlow/ExpandedFundList/ExpandedFundList';
import StepExpanded from '../../Shared/StepExpanded/StepExpanded';
import { getSellWithholdingWarned } from '../../../redux/modules/progress';
import { getDeliveryMethod } from '../../../redux/modules/sellDeliveryMethod/sellDeliveryMethod.selectors';
import {
  AddQCDFund,
  DeleteQCDFund,
  updateQCDFundAmount,
} from '../../../redux/modules/qcd/qcd.module';
import {
  getEligibleQCDFundsList,
  getQCDSelectedFunds,
} from '../../../redux/modules/qcd/qcd.selectors';
import {
  updateSellFund,
  updateSellFundAmount,
} from '../../../redux/modules/sellTransaction/actions';
import QCDFundEditor from './QCDFundEditor/QCDFundEditor';
import {
  getHasNotInheritedSEPOrSimpleIRA,
  getTransactionLimit,
} from '../../../redux/modules/sellTransaction/sellTransaction.selectors';
import { getUserAddress } from '../../../redux/modules/user/PersonalInformation/personalInformation.selectors';

const QCDFundsList = ({ actions, isSalesforceRep, customerWebViewEnabled }) => {
  const dispatch = useDispatch();
  const { openModal } = moduleActions;
  const selectedFunds = useSelector(getQCDSelectedFunds);
  const handleSelectFund = useCallback(
    (agreementID) => {
      if (selectedFunds[agreementID]?.selected) {
        // if selected dispatch action
        dispatch(DeleteQCDFund(agreementID));
      } else {
        // if selected dispatch action
        dispatch(AddQCDFund(agreementID));
      }
    },
    [dispatch, selectedFunds]
  );

  const sellWithholdingWarned = useSelector(getSellWithholdingWarned);
  const deliveryMethod = useSelector(getDeliveryMethod);
  const transactionLimit = useSelector(getTransactionLimit);
  const hasNotInheritedSEPOrSimpleIRA = useSelector(
    getHasNotInheritedSEPOrSimpleIRA
  );
  const userAddress = useSelector(getUserAddress);
  const openModalAction = useCallback(
    (...arg) => dispatch(openModal(...arg)),
    [dispatch, openModal]
  );
  const qcdFunds = useSelector(getEligibleQCDFundsList);
  return (
    <StepExpanded className="rothconvert-from-form">
      <div className="rothconvert-from-form-fund-list">
        <ExpandedFundList
          {...{
            transactionLimit,
            userAddress,
            hasNotInheritedSEPOrSimpleIRA,
          }}
          actions={{
            actions,
            sellWithholdingWarned,
            deliveryMethod,
            selectFund: handleSelectFund,
            deselectFund: handleSelectFund,
            updateSellFund,
            updateSellFundAmount,
            updateQCDFundAmount,
          }}
          showAddNewFundOrAccountEvenIfEmpty={false}
          availableFunds={qcdFunds || []}
          numberOfFunds={qcdFunds.length}
          currentStep={3}
          onSelectFund={handleSelectFund}
          fundEditor={() => QCDFundEditor}
          isManySelect={true}
          openModal={openModalAction}
          personalData={{}}
          priorYearInclusiveRemainingContributions={null}
          quickBuy={{}}
          shoppingCart={{}}
          isSalesforceRep={isSalesforceRep}
          customerWebViewEnabled={customerWebViewEnabled}
        />
      </div>
      <div className="rothconvert-from-form_allocation" />
    </StepExpanded>
  );
};

export default QCDFundsList;
